/* eslint-disable */
const axios = require( 'axios' );
    function HttpRequest() {}

HttpRequest.prototype.postRequest = function ( url, data, callback, header, timeout ) {
    if ( timeout ) {
        axios.defaults.timeout = timeout;
    } else {
        axios.defaults.timeout = 30000;
    }
    this.httpHandle( url, data, callback, header, 'post' );
};

HttpRequest.prototype.getRequest = function ( url, data, callback, header, timeout ) {
    if ( timeout ) {
        axios.defaults.timeout = timeout;
    } else {
        axios.defaults.timeout = 30000;
    }
    this.httpHandle( url, data, callback, header, 'get' );
};

// 中间件处理
HttpRequest.prototype.callbackHandle = function ( isSuccess, res, error, callback ) {
    callback( isSuccess, res, error );
};

HttpRequest.prototype.httpHandle = function ( url, data, callback, header = {}, type ) {
    this.http( url, data, ( isSuccess, res, error )=>{
        this.callbackHandle( isSuccess, res, error, callback );
    }, header, type );
};

HttpRequest.prototype.http = function ( url, params, callback, header = {}, type ) {
    if ( header.responseType === 'arraybuffer' ) {
        axios.post( url, params, { responseType: 'arraybuffer' } )
            .then( res => {
                return 'data:image/png;base64,' + btoa(
                    new Uint8Array( res.data )
                        .reduce( ( data, byte ) => data + String.fromCharCode( byte ), '' )
                );
            } )
            .then( data => {
                if ( callback ) {
                    callback( true, data );
                }
            } ).catch( err=>{
                //console.log( 'http-post-callback error', url, err );
                if ( callback ) {
                    callback( false, null, { errorNo: -1, errorMsg: err.message } );
                }
            } );
    } else {
        //console.log( 'http:', url, params );
        const getParams = { method: type, url: url, headers: header, params: params },
            postParams = { method: type, url: url, headers: header, data: params }
        axios( type === 'get' ? getParams : postParams )
            .then( res=>{
                //console.log( 'http-callback', url, res );
                if ( callback ) {
                    callback( true, res.data );
                }
            } ).catch( err=>{
                console.log( 'http-post-callback error', url, err );
                if ( callback ) {
                    callback( false, null, { errorNo: -1, errorMsg: err.message } );
                }
            } );
    }
};
export default HttpRequest;



// WEBPACK FOOTER //
// ./src/utils/request.js